export default __webpack_public_path__ + "static/media/lindaa-profile.b06386dc.png";